import React from 'react'
import { InternalUserPermission } from '../../../enum/InternalUserPermission'
import usePermission from './usePermission'

interface PermissionGuardProps {
    permission: InternalUserPermission
    /**
     * "hide"    — renders nothing when permission is denied (default)
     * "disable" — renders children with `disabled` prop injected when denied
     */
    mode?: 'hide' | 'disable'
    /** Rendered instead of children when mode="hide" and permission is denied */
    fallback?: React.ReactNode
    children: React.ReactElement
}

const PermissionGuard: React.FC<PermissionGuardProps> = ({
    permission,
    mode = 'hide',
    fallback = null,
    children,
}) => {
    const allowed = usePermission(permission)

    if (mode === 'disable') {
        return React.cloneElement(children, { disabled: !allowed })
    }

    return allowed ? children : <>{fallback}</>
}

export default PermissionGuard
